import baseUrl from './base';

export const postConnexion = () => `${baseUrl}/regisseurs/connexion`;
export const getRegisseurs = ({ page, identifiantLogin } = { page: 1, identifiantLogin: null }) =>
  `${baseUrl}/regisseurs?page=${page}${identifiantLogin ? `&identifiantLogin=${identifiantLogin}` : ''}`;
export const deleteRegisseur = (id) => `${baseUrl}/regisseurs/${id}`;

export const getSupprimable = (id) => `${baseUrl}/regisseurs/${id}/supprimable`;
